import { AxiosResponse } from 'axios';

export default function extractNoneFieldErrors(
  response: AxiosResponse,
  defaultMessage = '',
): string {
  let message = defaultMessage;
  if ('non_field_errors' in response?.data) {
    const nonFieldErrors = response.data['non_field_errors'];
    if (Array.isArray(nonFieldErrors)) {
      message = nonFieldErrors[0];
    } else {
      message = nonFieldErrors;
    }
  }
  return message;
}
